<template>
    <div class="loader">
        <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style >

.loader {
    width:  100%;
    height: 100%;
    position: absolute;
    top: 0%;
    left: 0%;
    pointer-events: none;
    z-index:1!important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.loader i {
    height: 100%;
    display: flex;
    font-size: 2.5em!important;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    color:#1660ab;
    z-index:1!important;
}
</style>